import { Analytics, ErrorService } from "@services";
import { useEffect } from "react";
import { useTheme } from "./useTheme";

export const useApplicationBootstrap = () => {
  const { hydrate } = useTheme();

  useEffect(() => {
    Analytics.load();
    ErrorService.init();
    hydrate();
  }, []);
};
